import getLandingMessage from '../routes/landing/getLandingMessage';
import messages from '../locale/messages';

export function getSiteSeoFromStore(store) {
  const settings = store.getState().siteSettings?.data || {};
  return {
    siteTitle: (settings.siteTitle && String(settings.siteTitle).trim()) || 'MotoStream',
    metaDescription: (settings.metaDescription && String(settings.metaDescription).trim()) || '',
  };
}

export function buildPageTitle(store, pageLabel) {
  const { siteTitle } = getSiteSeoFromStore(store);
  return `${siteTitle} – ${pageLabel}`;
}

export function siteMetaDescriptionOrFallback(store, fallbackMessageDef) {
  const { metaDescription } = getSiteSeoFromStore(store);
  if (metaDescription) {
    return metaDescription;
  }
  if (fallbackMessageDef) {
    return getLandingMessage(store, fallbackMessageDef);
  }
  return getLandingMessage(store, messages.newLandingMetaDescription);
}

export function staticPageSeo(store, cmsPage, { title, description }) {
  const metaTitle = cmsPage?.metaTitle && String(cmsPage.metaTitle).trim();
  const metaDescription = cmsPage?.metaDescription && String(cmsPage.metaDescription).trim();
  return {
    title: metaTitle || title,
    description: metaDescription || description,
  };
}

export function getBatch2PageSeo(store, titleMessageDef, descriptionMessageDef) {
  return {
    title: getLandingMessage(store, titleMessageDef),
    description: descriptionMessageDef
      ? getLandingMessage(store, descriptionMessageDef)
      : '',
  };
}
